<template>
  <div
    class="style1-wap"
    :class="{
      must: fieldObj.required == 1,
      err: fieldObj.dirty && fieldObj.invalid,
      statusNoBorder: fieldStyle == 'style2-wap'
    }"
  >
    <div class="u-label">
      {{ fieldObj.displayName }}
    </div>
    <div class="m-radio-list-wap img-list">
      <div
        class="opts"
        v-for="(o, i) in fieldObj.listOptions"
        :key="o.optionId"
        :class="{
          'item-other': o.isOther == 1
        }"
      >
        <div class="opt-img" v-if="o.picUrl">
          <img
            :src="o.picUrl"
            alt=""
            @click="
              showImg(
                o.picUrl,
                o.optionValue,
                fieldObj.options[i].optionDescText ||
                  fieldObj.options[i].optionDescHrefText,
                fieldObj.options[i].optionDescHref
              )
            "
          />
        </div>
        <a-radio
          class="m-radio-item"
          @change="onChange"
          :value="o.optionId"
          :disabled="fieldObj.disabled"
          :checked="fieldObj.model.optionId == o.optionId"
        >
          {{ o.optionValue }}
          <input
            class="otherInput"
            v-if="o.isOther == 1"
            type="text"
            v-model="o.otherValue"
            @blur="inputBlur($event, o)"
          />
        </a-radio>
        <div
          class="u-reg-err-tips"
          v-if="
            o.checked &&
              o.otherisFillIn == 1 &&
              o.otherIsRequire == 1 &&
              !o.otherValue
          "
        >
          请填写
        </div>
      </div>
    </div>
    <div class="u-reg-err-tips" v-if="fieldObj.dirty && fieldObj.invalid">
      {{ fieldObj.validationMessage }}
    </div>
    <div class="img-view" v-if="isShow">
      <div class="view-box view-box-wap">
        <div class="title">{{ title }}</div>
        <div class="img-box">
          <div class="close" @click="close">&times;</div>
          <img :src="src" alt="" />
        </div>
       <div class="desc" v-if="!href && desc" :class="{
          'desc-left': desc.indexOf('&|&') > -1
        }">{{ desc.replace('&|&','') }}</div>
        <div class="desc" v-if="href">
          <a :href="href">{{ desc }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import radioImgMixin from "../../field/new-fields/radio-img";
export default {
  name: "sk-radio-img-wap",
  mixins: [radioImgMixin]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.hello {
  text-align: left;
  padding: 20px;
}
</style>
